import React from 'react';
import { connect } from 'react-redux';
import { push as changeURL } from 'react-router-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames';

import sharedCSS from '../../shared.css';
import stateData from '../../../misc/country-info';
import { getUrlQeury } from '../../../misc/formatUrlquery';

import css from './index.css';

const Breadcrumb = props => {
  const query = getUrlQeury() || {};
  const state = query.from_state || query.from_state_name;
  const country = query.from_country || query.from_country_name;
  const city = query.from_city;
  const countryList = stateData[country] || [];
  const stateList = countryList.filter(x => x.value === state);
  const stateFullName = stateList.length ? stateList[0].label : '';

  const jumpTo = url => {
    props.gotoPage(url);
  };

  if (city && stateFullName) {
    return (
      <div className={css.container}>
        <span className={css.breadcrumbItem} onClick={() => jumpTo('/')}>
          Home
        </span>
        <a
          className={css.breadcrumbItem}
          onClick={() =>
            jumpTo(
              `/searchloads/${stateFullName}?from_country_name=${country}&from_state_name=${state}`
            )
          }>
          {stateFullName}
        </a>
        <span className={css.text}>{city}</span>
      </div>
    );
  } else if (!city && stateFullName) {
    return (
      <div className={css.container}>
        <span className={css.breadcrumbItem} onClick={() => jumpTo('/')}>
          Home
        </span>
        <span className={css.text}>{stateFullName}</span>
      </div>
    );
  }
  return (
    <div className={css.container}>
      <span className={css.breadcrumbItem} onClick={() => jumpTo('/')}>
        Home
      </span>
      <span className={css.text}>Anywhere</span>
    </div>
  );
};

export default connect(
  user => ({ user }),
  mapDispatch({
    gotoPage: (_, url) => changeURL(url),
  })
)(Breadcrumb);



// WEBPACK FOOTER //
// ./src/components/search/breadcrumb/index.js